/**
 * Authentication types for Poker Reborn
 *
 * Shared by LoginScreen implementations and AuthService.
 *
 * @see docs/screens/login/README.md - Login flow overview
 */

// =============================================================================
// ODOO AUTH TYPES
// =============================================================================

/** Player credentials returned from Odoo after social auth */
export interface PlayerAuthData {
  username: string;
  password: string;
  chips: number;
  profile?: string;
}

/** Odoo API response for auth endpoints */
export interface OdooAuthResponse {
  success: boolean;
  error?: string;
  message?: string;
  player?: PlayerAuthData;
  session_token?: string;
  token_expires_at?: string;
}

/** Response from POST /auth/guest */
export interface GuestAuthResponse {
  success: boolean;
  player?: PlayerAuthData;
  error?: string;
  message?: string;
  session_token?: string;
  token_expires_at?: string;
}

/** Response from POST /auth/validate */
export interface ValidateResponse {
  success: boolean;
  error?: string;
  message?: string;
}

/** Response from POST /auth/{provider}/link */
export interface LinkAuthResponse {
  success: boolean;
  player?: PlayerAuthData;
  error?: string;
  message?: string;
  session_token?: string;
  token_expires_at?: string;
}

// =============================================================================
// AUTH ERROR
// =============================================================================

/** Authentication error with code for specific handling */
export class AuthError extends Error {
  constructor(
    public code: string,
    message: string
  ) {
    super(message);
    this.name = 'AuthError';
  }
}
